import { call, put, takeEvery } from 'redux-saga/effects'
import { generalDoFailure } from '../../../util/fetchFailure'
import { privateFetch } from '../../../fetch'

import { API_URL_PATH_CUSTOMERS } from '../../../../../constants'

import {
  saveKegCollectionBookingCollectors,
  fetchKegCollectionBookingCollectorsRequest,
  fetchKegCollectionBookingCollectorsSuccess,
  fetchKegCollectionBookingCollectorsFailure,
} from './utils'

import { FETCH_KEG_COLLECTION_BOOKING_COLLECTORS } from '../../../../actions/actionTypes'

function* fetchCollectorsWorker(action) {
  if (!action) return

  const { customerParams } = action.payload || {}

  yield put(fetchKegCollectionBookingCollectorsRequest())

  try {
    const response = yield call(privateFetch, {
      path: API_URL_PATH_CUSTOMERS,
      params: customerParams,
    })

    const collectors = response.data || []
    yield call(doSuccessCollectors, collectors)
  } catch (error) {
    // If status is 404, return empty array
    if (error.response?.status === 404) {
      yield call(doSuccessCollectors, [])
      return
    }
    yield call(doFailureCollectors, error)
  }
}

export default [[takeEvery, FETCH_KEG_COLLECTION_BOOKING_COLLECTORS, fetchCollectorsWorker]]

function* doSuccessCollectors(collectors) {
  yield put(saveKegCollectionBookingCollectors(collectors))
  yield put(fetchKegCollectionBookingCollectorsSuccess())
}

function* doFailureCollectors(error) {
  yield call(generalDoFailure, { error, action: fetchKegCollectionBookingCollectorsFailure(error) })
}
